export { TruncatedText } from './TruncatedText';
